<template>
  <div id="objects-list">
    <v-flex v-if="homepage && $vuetify.breakpoint.smAndUp" xs12 mb-4 >
      <my-loader v-if="progressHot" :spacing="50" />
      <object-images
        v-else
        :images="computedHotImages"
        :img-folder="'objectImages/large'"
      />
    </v-flex>

    <v-layout
        id="list-filter-position"
        :style="'height: ' + (fixFilterButtonsOnMobile ? 56 : 1) + 'px;'"
    >
      <v-flex>
        <!-- placeholder for filters for mobile -->
      </v-flex>
    </v-layout>

    <v-layout
      v-if="!homepage"
      :class="'list-filter-buttons ' + (fixFilterButtonsOnMobile ? 'filter-buttons-fixed' : '')"
    >
      <v-flex xs4 style="background: #ddd;">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn float block tile class="elevation-0"
                   v-on="on"
            >
              <v-icon>
                fa-sort-alpha-down
              </v-icon>
              {{ currentSortTitle }}
            </v-btn>
          </template>
          <v-list style="cursor: pointer;">
            <v-list-tile @click="changeSort('sortOrder')">
              <v-list-tile-title>{{ $t('sorteeri') }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="changeSort('dayPrice')">
              <v-list-tile-title>{{ $t('sorteeri_hind') }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="changeSort('region')">
              <v-list-tile-title>{{ $t('sorteeri_asukoht') }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>

      <v-flex
          v-if="$vuetify.breakpoint.smAndDown"
          xs4 style="background: #ddd; border-right: 1px solid #ddd;border-left: 1px solid #ddd;"
      >
        <v-btn float block tile class="elevation-0"
          @click="showFilters()"
        >
          <v-icon>
            fa-filter
          </v-icon>
          {{ $i18n.t('filter') }}
        </v-btn>
      </v-flex>

      <v-flex
        v-else
      >
        <v-btn float block tile class="elevation-0"
               @click="goToFavorites()"
        >
          <i
              :class="searchFilters.favorites === 1 ? 'fa fa-heart' : 'far fa-heart'"
              style="color: #E53935; position: relative; cursor: pointer;"
              v-tooltip.bottom-end="$t('saved_favorites')"
          ></i>
          {{ $i18n.t('favourites') }}
        </v-btn>
      </v-flex>
      <v-flex xs4 style="background: #ddd;">

        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn float block tile class="elevation-0"
                   v-on="on"
            >
              <v-icon>
                fa-map-marked-alt
              </v-icon>
              {{ regionFilterTitle }}
            </v-btn>
          </template>
          <v-list style="cursor: pointer;">
            <v-list-tile
                @click="changeRegion({})"
            >
              <v-list-tile-title>{{ capitalize($i18n.t('näita_kõik')) }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
                v-for="(objectRegion, ori) in objectRegions.filter(objectRegion => !objectRegion.hidden)"
                :key="ori"
                @click="changeRegion(objectRegion)"
            >
              <v-list-tile-title>{{ objectRegion.regionName }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
    </v-layout>

    <v-flex
      v-if="!homepage && homepage"
      xs12 py-2
      style="text-align: right;"
    >
      <select v-model="searchFilters.sortBy" type="text" name="list_sort_by" style="color: rgb(128, 128, 128);">
        <option style="color: black" value="sortOrder">{{ $t('sorteeri') }}</option>
        <option style="color: black" value="dayPrice">{{ $t('sorteeri_hind') }}</option>
        <option style="color: black" value="region">{{ $t('sorteeri_asukoht') }}</option>
      </select>
    </v-flex>
    <div :class="homepage ? 'homepage-list-container' : ''">
      <object-list-info
        v-for="(object, index) in searchResult"
        :key="index"
        :object="object"
      />
      <center v-if="searchResult && searchResult.length === 0"><h1><b>{{ $t('objekte_ei_leitud') }}</b></h1></center>
    </div>
    <div class="text-xs-center">
      <v-pagination
        v-if="searchTotal > 0"
        v-model="searchFilters.page"
        :length="paginationLength"
        :total-visible="$vuetify.breakpoint.smAndUp ? 15 : 6"
        color="#fac400"
        circle
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import MyLoader from './../components/_MyLoader'
import ObjectImages from './ObjectImages'
import sharedMethods from './../methods/sharedMethods'
import ObjectListInfo from './ObjectListInfo'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ObjectsList',

  data () {
    return {
      filtersOffsetTop: 0,
    }
  },

  components: {
    ObjectListInfo,
    ObjectImages,
    MyLoader
  },

  computed: {
    ...mapFields(Object.keys(state)),

    fixFilterButtonsOnMobile () {
      return false
      // return this.scrolledTop + 48 > this.filtersOffsetTop && this.windowWidth < 500 && this.windowWidth < this.windowHeight
    },

    currentSortTitle () {
      const byKey = {
        sortOrder: this.$i18n.t('sorteeri'),
        dayPrice: this.$i18n.t('sorteeri_hind'),
        region: this.$i18n.t('sorteeri_asukoht'),
      }
      return byKey[this.searchFilters.sortBy]
    },

    regionFilterTitle () {
      if (parseInt(this.searchFilters.region)) {
        return this.objectRegions.filter(region => region.id === this.searchFilters.region)[0]
            .regionName
      }
      return this.$i18n.t('region_short')
    },

    paginationLength () {
      return Math.ceil(this.searchTotal / (
        this.isHomepage
          ? this.rowsPerHomePage
          : this.searchFilters.rowsPerPage
        ))
    },

    homepage () {
      return this.$route.name === 'homewlang' || this.$route.name === 'home'
    },

    page () {
      return this.searchFilters.page
    },

    sortBy () {
      return this.searchFilters.sortBy
    },

    computedHotImages () {
      return this.hotImages
        .filter(ad => ad.objectImages && ad.objectImages[0] && ad.visible)
        .map(ad => {
          let image = ad.objectImages[0]
          image.objectInfo = ad
          image.linkToObject = true
          return image
      })
    }
  },

  created () {
    this.setFiltersOffsetTop()
    window.addEventListener('scroll', this.scrollHandler)
    window.addEventListener('click', this.scrollHandler)
  },

  destroyed () {
    window.removeEventListener('scroll', this.scrollHandler)
    window.removeEventListener('click', this.scrollHandler)
  },

  watch: {
    sortBy (value) {
      if (this.searchFilters.page !== 1) {
        this.searchFilters.page = 1
      } else {
        this.searchObjects(true)
      }
    },
    page (value) {
      // Scroll to top first, otherwise scroll to search position
      // not working on Android
      // For mobile this happens inside searchObjects
      if (this.$vuetify.breakpoint.smAndDown) {
        window.scrollTo(0, 0)
      }
      this.$nextTick(() => {
        this.searchObjects(!this.homepage)
        if (!this.$vuetify.breakpoint.smAndDown) {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })
        }
      })
    }
  },

  methods: {
    ...sharedMethods,

    scrollHandler () {
      this.setFiltersOffsetTop()
    },

    clickHandler () {
      this.setFiltersOffsetTop()
    },

    setFiltersOffsetTop () {
      const el = document.getElementById('list-filter-position')
      if (!el) { return }
      this.filtersOffsetTop = el.offsetTop
    },

    showFilters () {
      this.detailedSearch = true
      document.location.href = '#searchfilters'
    },

    changeSort (condition) {
      Vue.set(this.searchFilters, 'sortBy', condition)
    },

    changeRegion (region) {
      Vue.set(this.searchFilters, 'region', region.id)
      this.searchFormSubmit()
    }
  }
}
</script>

<style lang="stylus">
.filter-buttons-fixed
  position fixed
  z-index 5
  top 42px
  background: white;
  padding: 5px 0;
  width calc(100% - 10px)
.list-filter-buttons
  margin: 5px -10px 15px -10px;
  /*border: 1px solid #bbb; */
  display flex
  .v-btn:hover:before
    background-color transparent !important
  button
    background white !important
    color #777 !important
    height 40px
    margin 0
    padding 0
    text-transform none
    font-size 14px
    i
      font-size 16px
      margin-right 10px
@media only screen and (min-width: 959px)
  .list-filter-buttons
    margin: 0 -10px 15px -10px;
    button
      background white !important
      height 35px
</style>
